import axios from 'axios';

const BASE_URL = 'https://inventariosbackend.velasresorts.com/inventarios/depreciacion';

const depreciacionApi = {
    anios: async () => {
        try {
            const response = await axios.get(`${BASE_URL}/anios`);
            return Array.isArray(response.data) ? response.data : [];
        } catch (error) {
            console.error('Error fetching años de depreciación:', error);
            return [];
        }
    },

    listado: async (anio: number) => {
        try {
            const response = await axios.get(`${BASE_URL}/listado`, { params: { anio } });
            return Array.isArray(response.data) ? response.data : [];
        } catch (error) {
            console.error('Error fetching tabla de depreciación:', error);
            return [];
        }
    },

    crear: async (data: { Categoria: string; Porcentaje: number; Anio: number }) => {
        const response = await axios.post(`${BASE_URL}/crear`, data);
        return response.data;
    },

    editar: async (id: number, data: { Categoria: string; Porcentaje: number }) => {
        const response = await axios.put(`${BASE_URL}/editar/${id}`, data);
        return response.data;
    },

    eliminar: async (id: number) => {
        const response = await axios.delete(`${BASE_URL}/eliminar/${id}`);
        return response.data;
    },

    duplicarAnio: async (anioOrigen: number, anioDestino: number) => {
        const response = await axios.post(`${BASE_URL}/duplicar-anio`, { anioOrigen, anioDestino });
        return response.data;
    },
};

export default depreciacionApi;
